import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {MatSidenav} from '@angular/material/sidenav';
import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  @ViewChild('menuSidenav')
  menuDrawer: MatSidenav;

  isOnAdmin = false;
  isMobile = false;

  constructor(private router: Router,
              private breakpointObserver: BreakpointObserver) {
  }

  ngAfterViewInit(): void {
    this.router.events
        .pipe(
            filter(event => event instanceof NavigationEnd)
        )
        .subscribe((event: NavigationEnd) => {
          this.isOnAdmin = event.urlAfterRedirects.startsWith('/admin');
          if (this.isOnAdmin) {
            // use set timeout to handle the menu after change detection runs
            // and ngIf resolves the menuDrawer reference
            setTimeout(() => this.handleMenu(), 0);
          }
        });

    this.breakpointObserver
        .observe(['(max-width: 959px)'])
        .subscribe((state: BreakpointState) => {
          this.isMobile = state.matches;
          if (this.isOnAdmin) {
            this.handleMenu();
          }
        });
  }

  handleMenu() {
    if (this.isMobile) {
      this.menuDrawer.close();
    } else {
      this.menuDrawer.open();
    }
  }

  async toggleSidenav() {
    await this.menuDrawer.toggle();
  }
}
